import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickCardButton',
  props: {
    effect: {}
  },
  setup(__props: any) {

const props = __props;

const { iconPath, getCustomIconStyle } = useCustomIcon();

const { translate } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "add-card-toolbar-icon pt flex items-center justify-center",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.effect && props.effect(...args)))
  }, [
    _createElementVNode("em", {
      class: "custom-icons page-toolbar mr-1 group-hover:bg-icon-hover",
      style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('plus2')))
    }, null, 4),
    _createTextVNode(" " + _toDisplayString(_unref(translate)('card')), 1)
  ]))
}
}

})